export default __webpack_public_path__ + "static/media/img_fee_90.4f00e26d.svg";